module.exports = __webpack_public_path__ + "img/2c2p.d6152386.png";